<template>
  <div>
    <v-row class="mt-5 v-row-overflow">
      <v-col cols="12" class="v-col-overflow">
        <v-card
          flat
          class="rounded-lg primary--text pe-3"
          :style="$vuetify.breakpoint.md ? 'font-size: 14px !important;' : ''"
        >
          <v-row align="center">
            <v-col cols class="text-start" style="width: 250px">
              <div class="ps-3">
                {{ $t("user.registration.name") }}
              </div>
            </v-col>

            <v-col cols class="text-start" style="width: 250px">
              {{ $t("user.registration.training") }}
            </v-col>

            <v-col cols class="text-start" style="width: 250px">
              {{ $t("course.trainer") }}
            </v-col>

            <v-col cols class="text-start" style="width: 250px">
              {{ $t("user.registration.organization") }}
            </v-col>

            <v-col cols="auto" class="text-start" style="width: 150px">
              {{ $t("batch.batchNumber") }}
            </v-col>

            <v-col cols="auto" class="text-start" style="width: 200px">
              {{ $t("user.registration.registrationStatus") }}
            </v-col>

            <v-col cols="auto" class="text-start" style="width: 250px">
              {{ $t("user.registration.employeeId") }}
            </v-col>

            <v-col cols="auto" class="text-start" style="width: 180px">
              {{ $t("user.registration.startDate") }}
            </v-col>

            <v-col cols="auto" class="text-start" style="width: 200px">
              {{ $t("reports.certificateExpiryDate") }}
            </v-col>

            <div>
              <v-btn icon depressed color="error" style="visibility: hidden">
                <v-icon> mdi-trash-can-outline </v-icon>
              </v-btn>
            </div>
          </v-row>
        </v-card>
      </v-col>

      <v-col v-if="loading" cols="12" class="text-center my-16">
        <v-progress-circular indeterminate color="primary" />
      </v-col>

      <v-col v-else-if="datas.length" cols="12" class="v-col-overflow">
        <v-row class="d-flex flex-column">
          <v-col
            v-for="(data, index) in datas"
            :key="index"
            cols="12"
            class="v-col-overflow flex"
          >
            <RegistrationCard
              :registrationData="data"
              @onDelete="deleteTrainingRegistration"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col v-else cols="12" class="my-16">
        {{ $t("noItems") }}
      </v-col>
    </v-row>

    <v-snackbar
      :value="snackbarError"
      @input="resetSnackbar"
      timeout="3000"
      color="error"
    >
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="resetSnackbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import RegistrationCard from "./RegistrationCard.vue";

import { deleteTrainingRegistration } from "@/app/course-module/methods/deleteTrainingRegistration";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  components: {
    RegistrationCard,
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
    };
  },
  computed: {
    havePermissionDeleteTrainingRegistration() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_TRAINING_REGISTRATION"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    resetSnackbar() {
      this.snackbarError = false;
      this.snackbarErrorMessage = null;
    },
    onError(type) {
      let msg = null;

      if (type === "delete") {
        msg = this.$t("deleteFailed");
      } else if (type === "update") {
        msg = this.$t("updateFailed");
      }

      this.snackbarError = true;
      this.snackbarErrorMessage = msg;
    },
    deleteTrainingRegistration(id) {
      this.$dialog
        .confirm(this.$t("user.registration.confirmDelete"), { loader: true })
        .then(dialog => {
          deleteTrainingRegistration(id).then(res => {
            if (res.data) this.$emit("reFetch");
            if (res.error) this.onError("delete");

            dialog?.close();
          });
        })
        .catch(_ => {});
    },
  },
};
</script>
